import { useState } from 'react';

import Modal from '../../../../Components/Modal';

//mui imports====
import useStyles from '../../styles';
import Typography from '@mui/material/Typography';
import { Grid, Box } from '@mui/material';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
//===============

const PushDocModal = ({ modalState, setModalState, pushDocToCouchBase, docId }) => {
	const classes = useStyles('./styles');

	const [confirmInput, setConfirmInput] = useState('');

	const pushDoc = () => {
		if (confirmInput === 'Confirm') {
			setConfirmInput('');
			setModalState(false);
			pushDocToCouchBase();
		} else {
			alert('Write Confirm in the input box to update the doc');
		}
	};

	return (
		<Modal open={modalState} setOpen={setModalState}>
			<Grid container spacing={2} className={classes.superAdminModalContent}>
				<Grid item xs={12}>
					<Grid item xs={12}>
						<Typography className={classes.superAdminModalHeading} fontWeight={600} variant="h5">
							Update Doc Directly to CouchBase
						</Typography>
					</Grid>

					<Grid item>
						<Box p={2}>
							<Typography className={classes.superAdminModalHeading} fontWeight={600} variant="h7">
								Write "Confirm" here if you want to update the doc
							</Typography>
							<TextField
								id="outlined-size-normal-side-id"
								style={{
									width: '100%',
									margin: '1rem 0',
									display: 'flex',
									justifyContent: 'center'
								}}
								value={confirmInput}
								onChange={(e) => {
									setConfirmInput(e.target.value);
								}}
								placeholder=""
							/>
						</Box>
					</Grid>

					<Grid item className={classes.superAdminModalContentItem}>
						<Grid item xs={4}>
							<Button
								variant="contained"
								fontWeight={600}
								style={{ marginTop: '5rem' }}
								onClick={() => setModalState(!modalState)}
							>
								Cancel
							</Button>
						</Grid>

						<Grid item xs={2}>
							<Button
								variant="contained"
								fontWeight={600}
								style={{ marginTop: '5rem' }}
								onClick={pushDoc}
							>
								Confirm
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Modal>
	);
};

export default PushDocModal;
